import { FormattedMessage } from "react-intl";
import { useSearchParams } from "react-router-dom";
import useStoreLinks from "../../../../common/features/store/useStoreLinks.ts";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import MiscellaneousTag from "../../../../common/icons/MiscellaneousTag.tsx";
import styles from "./NoResultsTemplate.module.scss";
import { ReactNode } from "react";
import { clsx } from "clsx";
import { getSearchQuery } from "../query.ts";
import NoResults from "common/graphics/NoResults.tsx";

export default function NoResultsTemplate({
  useStoreLink,
  message,
  title,
  className,
}: {
  useStoreLink?: boolean;
  message: ReactNode;
  title: ReactNode;
  className?: string;
}) {
  const [params] = useSearchParams();
  const { isVstStore, makeStoreSearchUrl } = useStoreLinks();
  const query = getSearchQuery(params)!;

  return (
    <div className={clsx(styles.container, className)}>
      <NoResults className={styles.graphic} />
      <h2 className="template-h3">{title}</h2>
      <p>{message}</p>
      {useStoreLink && isVstStore && (
        <>
          <FormattedMessage
            defaultMessage="Still not finding what you’re looking for? Find hundreds of titles related to <b>{query}</b> on our Store!"
            tagName="p"
            values={{
              query,
              b: (chunks) => <strong>{chunks}</strong>,
            }}
          />
          <BaseLinkOrButton
            className="vst-button-pill vst-button-variant-outline"
            href={makeStoreSearchUrl(query, {
              utm_medium: "bookshelf-home-empty-search",
              utm_campaign: query,
            })}
          >
            <MiscellaneousTag />
            <FormattedMessage defaultMessage="Explore the VitalSource Store" />
          </BaseLinkOrButton>
        </>
      )}
    </div>
  );
}
